import { Facebook, Mail, MapPin, Phone } from "lucide-react";
import { ADDRESS_ONE_LINE, BUSINESS, FACEBOOK_URL, MAPS_URL } from "@/lib/site";

/** Compact contact utility bar above the sticky header. */
export function UtilityBar() {
  return (
    <div className="bg-forest-deep text-cream/90">
      <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-between gap-x-6 gap-y-1 px-4 py-2 text-[0.78rem] sm:px-6 lg:px-10">
        <div className="flex flex-wrap items-center gap-x-6 gap-y-1">
          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="link-underline hover:text-cream"
          >
            <MapPin className="size-3.5 shrink-0" aria-hidden="true" />
            <span>{ADDRESS_ONE_LINE}</span>
          </a>
          <a href={BUSINESS.phoneHref} className="link-underline hover:text-cream">
            <Phone className="size-3.5 shrink-0" aria-hidden="true" />
            <span>{BUSINESS.phone}</span>
          </a>
          <a
            href={`mailto:${BUSINESS.email}`}
            className="link-underline hidden hover:text-cream sm:inline-flex"
          >
            <Mail className="size-3.5 shrink-0" aria-hidden="true" />
            <span>{BUSINESS.email}</span>
          </a>
        </div>
        <a
          href={FACEBOOK_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Amigo Inn & RV Park on Facebook"
          className="inline-flex size-7 items-center justify-center rounded-full border border-cream/25 transition-colors hover:bg-cream/15"
        >
          <Facebook className="size-3.5" aria-hidden="true" />
        </a>
      </div>
    </div>
  );
}
